function Title({ title }) {
  return <h2 className="titre animate__animated animate__backInUp">{title}</h2>;
}
export default Title;
